import { memo, useMemo } from 'react'
import { useWireValue } from '@forminator/react-wire'
import { user as storeUser, remoteConfig as storeRemoteConfig } from '@store'
import { Routes, Route, Navigate } from 'react-router-dom'
import routes from '@/routes'
import { ROLE_ANNOTATOR_USER, ROLE_CHECK_MANAGER } from '@constants/roles'
import {
    renderRoute,
    debugRouteFailure,
    showErrorForRouteFailures,
} from './App.lib'
import useUserHasRoles from '@/hook/useUserHasRoles'

import { ErrorBoundary } from 'react-error-boundary'
import ErrorFallback from '@components/shared/ErrorFallback'

// @todo
const ERROR_BOUNDARY_ENABLED = false

const AppRoutes = ({ children }) => {
    
    const user = useWireValue(storeUser)
    const remoteConfig = useWireValue(storeRemoteConfig)
    const isCheckManager = useUserHasRoles(ROLE_CHECK_MANAGER)
    const isAtrEnabled = useMemo(() => !!remoteConfig.atr?.enabled, [remoteConfig])
    
    const token = localStorage.getItem('jwt')
    const isAnnotator = useMemo(() => (
        user?.roles?.some(it => it.name === ROLE_ANNOTATOR_USER) || false
    ), [user])
    
    const isOnlyCheckManager = useMemo(() => {
        return isCheckManager && user.roles.length === 1
    }, [isCheckManager, user?.roles])
    
    // Attempt to redirect user to the app if they're already
    // authenticated, otherwise default back to the sign-in screen
    const redirectUrl = useMemo(() => {
        
        if (token?.length <= 0) return '/signin'
        if (isAnnotator) return '/partners'
        if (isOnlyCheckManager) return '/checks'
        if (isAtrEnabled) return '/atr'
        
        return '/collections'
    }, [token, isAnnotator, isOnlyCheckManager, isAtrEnabled])
    
    return (
        
        <>
            
            <Routes>
                <Route path="/" element={<Navigate to={redirectUrl} exact />} />
                {routes.map(renderRoute)}
                {showErrorForRouteFailures
                    ? debugRouteFailure
                    : <Route path="*" element={<Navigate to={redirectUrl} />} />}
            </Routes>
            
            {ERROR_BOUNDARY_ENABLED ? (
                <ErrorBoundary
                    fallback={<ErrorFallback />}
                    onReset={() => console.error('@todo reset error boundary setSomeKey(null)')}
                    resetKeys={['']}>
                    {children}
                </ErrorBoundary>
            ) : children}
        
        </>
        
    )
    
}

export default memo(AppRoutes)
